import React, { useContext } from "react";
import { getTrueClasses } from "../../../../helpers";
import { HeaderContext } from "../../../../store/context/header-context";

const Burger = () => {
  const { getState, openMenu } = useContext(HeaderContext);

  return (
    <div
      className={getTrueClasses(
        "GCL-H-MP-B",
        getState.isOpen ? "GCL-H-MP-B_opened" : "GCL-H-MP-B_closed"
      )}
      onClick={openMenu}
    />
  );
};
export default Burger;
